<div
  #root
  class="toolbar-root"
  [ngClass]="{
    'toolbar-root--dragging': isDragging,
    'toolbar-root--docked': docked,
    'toolbar-root--docked--left': docked === 'right',
    'toolbar-root--docked--right': docked === 'left',
    'toolbar-root--vertical': isVertical,
    'toolbar-root--horizontal': isHorizontal
  }"
  widgetlike-draggable
  [widgetlike-drag-disabled]="!!docked"
  (widgetlike-dragstart)="onDragStart($event)"
  (widgetlike-drag)="onDrag($event)"
  (widgetlike-dragend)="onDragged($event)"
  constrainer="body"
  (dblclick)="$event.stopPropagation()"
>
  <div class="toolbar">
    <div class="toolbar__header" widgetlike-drag-handle>
      <app-asset-icon width="24px" height="24px" icon="drag"></app-asset-icon>
    </div>

    <mat-divider [vertical]="isHorizontal"></mat-divider>

    <div class="toolbar__body">
      <ng-container *ngFor="let widgetType of widgetTypes; let i = index">
        <app-tool-action
          [widgetType]="widgetType"
          [toolPosition]="getToolPosition()"
          [disabled]="!!docked"
          [counter]="getCounterByName(widgetType.getIconName())"
          (onToolToggle)="handleToolToggle($event)"
        ></app-tool-action>
      </ng-container>
    </div>

    <mat-divider [vertical]="isHorizontal"></mat-divider>

    <div class="toolbar__footer">
      <button class="toolbar-action" (click)="flip($event)">
        <app-asset-icon
          width="1em"
          height="1em"
          icon="flip-horizontal"
          *ngIf="!isHorizontal"
        ></app-asset-icon>
        <app-asset-icon
          width="1em"
          height="1em"
          icon="flip-vertical"
          *ngIf="isHorizontal"
        ></app-asset-icon>
      </button>
    </div>

    <button
      class="toolbar__undock"
      [ngClass]="'toolbar__undock--' + docked"
      mat-mini-fab
      *ngIf="docked"
      (click)="undock()"
    >
      <mat-icon *ngIf="docked === 'right'">chevron_left</mat-icon>
      <mat-icon *ngIf="docked === 'left'">chevron_right</mat-icon>
    </button>
  </div>

  <div
    id="toolbar-widget-dock-container"
    class="toolbar__tools-container"
    [ngClass]="{
      'toolbar__tools-container--horizontal': isHorizontal,
      'toolbar__tools-container--vertical': !isHorizontal,
      'toolbar__tools-container--left': getToolPosition() === 'left',
      'toolbar__tools-container--right': getToolPosition() === 'right',
      'toolbar__tools-container--top': getToolPosition() === 'above',
      'toolbar__tools-container--bottom': getToolPosition() === 'below'
    }"
  >
    <ng-template #widgetWrapperInsertionPoint></ng-template>
  </div>
</div>

<div
  id="toolbar-widget-drag-container"
  [style]="{ top: 0, left: 0, position: 'fixed', zIndex: 3000 }"
>
  <ng-template #widgetWrapperInsertionPointFloating></ng-template>
</div>
